import { createReducer, createSelector, on } from "@ngrx/store";
import { FreightPayer } from "./models/FreightPayer";
import { loadFreightPayersSuccess } from "./freight-payer.actions";

export interface IFreightPayerState {
    freightPayers: FreightPayer[];
}

export const initialFreightPayerState: IFreightPayerState = {
    freightPayers: []
}

export const freightPayerReducer = createReducer(
    initialFreightPayerState,
    // Add action handlers here
    on(
        loadFreightPayersSuccess,
        (state, action) => {
            return {
                ...state,
                freightPayers: action.freightPayers
            }
        }
    ),
)

export const selectFreightPayerState = (state: any): IFreightPayerState => state.FreightPayerState;

export const selectAvailableFreightPayers = createSelector(
    selectFreightPayerState,
    (state) => state.freightPayers
)